import { textResolver, plainText, customPrismicLink } from "@sendmagic/prismic-nextjs/src/components/LinkTag";

export { plainText, customPrismicLink, textResolver };

export default textResolver;
